import { FormikHelpers } from "formik";
import SpeedForm from "./SpeedForm";
import { useGetSpeed } from "./api/getSpeed";
import { useEditSpeed } from "./api/editSpeed";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditSpeed = ({handleCloseModal, speedId}: EditSpeedProps)  => {
  const getSpeedQuery = useGetSpeed({speedId: speedId})
  const editSpeedMutation = useEditSpeed({data: {}, speedId});

  const handleSubmit = async (values: IPostEditSpeed, { setSubmitting }: FormikHelpers<IPostEditSpeed>): Promise<void> => {
    try {
      await editSpeedMutation.mutateAsync({
        data: values,
        speedId: speedId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getSpeedQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getSpeedQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Ταχύτητας Γραμμής.</div>
    )
  }

  return (
    <>
      {!getSpeedQuery.isLoading && getSpeedQuery.data &&
        <SpeedForm initialValues={getSpeedQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditSpeedProps {
  speedId: number;
  handleCloseModal: () => void;
}

export default EditSpeed;